// KwikPass Cart Drawer Fix v3
// Root cause: <cart-drawer> is nested inside an <a> tag in the header section.
// The browser ejects #CartDrawer to <body>, making this.drawer = null in the JS,
// so toggleDrawerClasses() silently fails. This fix manually opens the drawer.
(function () {
  'use strict';

  var lastCount = -1;
  var debounceTimer = null;
  var closeHandlersAttached = false;

  function getCartCount() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count; })
      .catch(function () { return -1; });
  }

  function closeDrawer() {
    var drawerEl = document.getElementById('CartDrawer');
    var cartDrawer = document.querySelector('cart-drawer');
    if (drawerEl) drawerEl.classList.remove('wt-cart__drawer--open');
    document.body.classList.remove('page-overlay-cart-on');
    if (cartDrawer) {
      cartDrawer.removeAttribute('open');
      cartDrawer.isOpen = false;
    }
  }

  function attachCloseHandlers() {
    if (closeHandlersAttached) return;
    closeHandlersAttached = true;

    // Close on close button click (event delegation, works even after content refresh)
    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('.wt-cart__drawer__close');
      if (closeBtn) {
        e.preventDefault();
        closeDrawer();
      }
    });

    // Close on overlay click
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('page-overlay-cart')) {
        closeDrawer();
      }
    });
  }

  function openDrawerManually() {
    var drawerEl = document.getElementById('CartDrawer');
    if (!drawerEl || drawerEl.classList.contains('wt-cart__drawer--open')) return;

    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        // Update #CartDrawer inner content with fresh cart items
        if (sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var freshInner = doc.querySelector('.wt-cart__drawer__inner');
          if (freshInner) {
            var existing = drawerEl.querySelector('.wt-cart__drawer__inner');
            if (existing) {
              existing.innerHTML = freshInner.innerHTML;
            }
          }
        }

        // Update cart icon bubble count
        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            var freshBubble = doc2.querySelector('.shopify-section');
            if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
          }
        }

        // Open the drawer by applying CSS classes
        drawerEl.classList.add('wt-cart__drawer--open');
        document.body.classList.add('page-overlay-cart-on');
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.setAttribute('open', '');
          cartDrawer.isOpen = true;
        }

        attachCloseHandlers();
      })
      .catch(function (e) { console.warn('[cart-fix] failed to open drawer', e); });
  }

  function checkAndMaybeOpen() {
    getCartCount().then(function (count) {
      if (count === -1) return;
      if (lastCount >= 0 && count > lastCount) {
        openDrawerManually();
      }
      lastCount = count;
    });
  }

  function initObserver() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;

    // Seed initial count
    getCartCount().then(function (c) { if (c !== -1) lastCount = c; });

    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(checkAndMaybeOpen, 200);
    });
    observer.observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();
